import { type ComponentType, memo } from 'react';

import { FilterLogicSelect } from '~/components/Filters/FilterLogicSelect';
import { type PrivateSmartTagsSelectProps } from '~/components/SmartTagSelect/PrivateSmartTagsSelect';
import { type SmartTagBase } from '~/components/SmartTagSelect/utils';
import { type FilterLogicType } from '~/store/filters/types';

export type SmartTagsFilterProps = {
  SmartTagsSelect: ComponentType<PrivateSmartTagsSelectProps>;
  selectedLogic: FilterLogicType;
  selectedSmartTags: SmartTagBase[];
  onLogicChange: (logic: FilterLogicType) => void;
  onSelectedSmartTagsChanged: (smartTags: SmartTagBase[]) => void;
};

export const SmartTagsFilter = memo(
  ({
    SmartTagsSelect,
    onLogicChange,
    onSelectedSmartTagsChanged,
    selectedSmartTags,
    selectedLogic,
  }: SmartTagsFilterProps) => {
    return (
      <div className="flex flex-col items-start">
        <SmartTagsSelect
          className="order-2 w-full"
          selectedSmartTags={selectedSmartTags}
          onSelectedSmartTagsChanged={onSelectedSmartTagsChanged}
        />
        <FilterLogicSelect className="order-1" selectedLogic={selectedLogic} onLogicChange={onLogicChange} />
      </div>
    );
  },
);

SmartTagsFilter.displayName = 'SmartTagsFilter';
